/*
 * Back in stock — custom sign-up (ticket 3c87c862 « Back in Stock », weekly 2026-10-06).
 *
 * Replaces Klaviyo's legacy onsite widget (klaviyo.enable("backinstock") in layout/theme.liquid), which swapped the
 * FIRST add-to-cart button of the page for its own link and opened a full-screen iframe: fragile with any other buy
 * button on the page (shop the look, 25/09), in conflict with the newsletter pop-up on mobile (Laurie 29/09: « impossible
 * de s'inscrire pour le torque sur la version mobile »), and unable to sit on product cards.
 *
 * Here every opener is a plain theme button carrying aria-controls="back-in-stock-modal" and data-bis-* attributes
 * (product page, sticky bar, product cards). The theme's <x-modal> opens on click of any [aria-controls] (DialogElement),
 * and passes the clicked element as `activator` in `dialog:before-show`: we fill the modal from it.
 *
 * The sign-up is sent to Klaviyo's public Client API (company id = the public key already used by the theme), so the
 * existing « Back in Stock » flow in Klaviyo keeps sending the restock e-mail. No secret key in the theme.
 */
(() => {
  const MODAL_ID = 'back-in-stock-modal';
  const ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  const REVISION = '2024-10-15';

  const modal = document.getElementById(MODAL_ID);
  if (!modal) return;

  const form = modal.querySelector('[data-bis-form]');
  const titleCategoryEl = modal.querySelector('[data-bis-title-category]');
  const titleNameEl = modal.querySelector('[data-bis-title-name]');
  const imageEl = modal.querySelector('[data-bis-image]');
  const variantWrapper = modal.querySelector('[data-bis-variant-wrapper]');
  const variantSelect = modal.querySelector('[data-bis-variant-select]');
  const variantInput = modal.querySelector('[data-bis-variant-id]');
  const emailInput = modal.querySelector('input[type="email"]');
  const submitButton = modal.querySelector('[data-bis-submit]');
  const successEl = modal.querySelector('[data-bis-success]');
  const errorEl = modal.querySelector('[data-bis-error]');
  const companyId = modal.dataset.companyId;

  const reset = () => {
    form.hidden = false;
    successEl.hidden = true;
    errorEl.hidden = true;
    submitButton.removeAttribute('aria-busy');
    submitButton.disabled = false;
  };

  modal.addEventListener('dialog:before-show', (event) => {
    const activator = event.detail?.activator;
    if (!activator) return;

    reset();
    // Two-level title: muted pre-title (category) above the model name, as everywhere else in the theme
    const titleCategory = activator.dataset.bisTitleCategory || '';
    titleCategoryEl.textContent = titleCategory;
    titleCategoryEl.hidden = titleCategory === '';
    titleNameEl.textContent = activator.dataset.bisTitleName || activator.dataset.bisProductTitle || '';

    if (activator.dataset.bisImage) {
      imageEl.src = activator.dataset.bisImage;
      imageEl.alt = activator.dataset.bisProductTitle || '';
      imageEl.hidden = false;
    } else {
      imageEl.hidden = true;
    }

    // Several sold-out variants (a card of a product with sizes / platings): let the visitor pick the one she wants
    let variants = [];
    try {
      variants = JSON.parse(activator.dataset.bisVariants || '[]');
    } catch (e) {
      variants = [];
    }

    variantSelect.innerHTML = '';
    if (variants.length > 1) {
      variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title;
        option.selected = String(variant.id) === String(activator.dataset.bisVariantId);
        variantSelect.append(option);
      });
      variantWrapper.hidden = false;
    } else {
      variantWrapper.hidden = true;
    }

    variantInput.value = activator.dataset.bisVariantId || '';
  });

  // Focus the e-mail once the modal is shown (not on touch: the keyboard would cover the product)
  modal.addEventListener('dialog:after-show', () => {
    if (window.matchMedia('(pointer: fine)').matches) emailInput.focus();
  });

  variantSelect.addEventListener('change', () => {
    variantInput.value = variantSelect.value;
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!emailInput.checkValidity()) {
      emailInput.reportValidity();
      return;
    }

    errorEl.hidden = true;
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');

    const body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: emailInput.value.trim() } } },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantInput.value}` } },
        },
      },
    };

    try {
      const response = await fetch(`${ENDPOINT}?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          accept: 'application/vnd.api+json',
          revision: REVISION,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) throw new Error(`Klaviyo ${response.status}`);

      form.hidden = true;
      successEl.hidden = false;
      document.dispatchEvent(new CustomEvent('back-in-stock:subscribed', { detail: { variantId: variantInput.value } }));
    } catch (error) {
      console.warn('[back-in-stock]', error);
      errorEl.hidden = false;
    } finally {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
    }
  });
})();
